import CommonButton from 'components/Buttons/CommonButton';
import Header from 'components/Modal/Header';
import Typography from 'components/Typography/Typography';
import { useTheme } from 'providers/ThemeProvider';
import React from 'react';
import { useDispatch, useSelector } from 'react-redux';
import actions from 'state/actions';
import selectors from 'state/selectors';
import styled from 'styled-components/macro';
import IntlHelper from 'utils/helpers/intl.helper';

export const ButtonContainer = styled.div`
  text-align: center;
  display: flex;
  justify-content: center;
  align-content: center;
  button {
    margin: 10px;
  }
`;

export const Content = styled.div`
  white-space: 'pre-wrap';
  max-height: 400px;
  overflow-y: auto;
`;

const ShowResponse = () => {
  const dispatch = useDispatch();
  const t = IntlHelper.useTranslator();
  const modalProps = useSelector(selectors.modal.getModalProps);
  const { isDarkMode } = useTheme();

  const { title, content } = modalProps;

  return (
    <>
      <Header title={t(title)} />
      <Content style={{ whiteSpace: 'pre-wrap' }}>
        {<Typography as="h4">{Array.isArray(content) ? content.join('\n') : content}</Typography>}
      </Content>
      <ButtonContainer>
        <CommonButton
          id="close-btn"
          value={t('close')}
          selected={isDarkMode ? true : false}
          scope={isDarkMode ? 'quaternary' : 'secondary'}
          action={() => {
            dispatch(actions.modal.closeModal());
          }}
        />
      </ButtonContainer>
    </>
  );
};

export default ShowResponse;
